import styled from 'styled-components';
import { Container } from '../../globalStyles';

export const PageWrapper = styled.div`
  background: #f7f8fc;
  min-height: 100vh;
  padding: 40px 0 80px;
`;

export const FormContainer = styled(Container)`
  max-width: 860px;
`;

export const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  color: #1410df;
  margin-bottom: 8px;

  @media screen and (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 40px;
`;

export const Section = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 32px 36px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(20, 16, 223, 0.07);

  @media screen and (max-width: 768px) {
    padding: 24px 20px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  color: #1410df;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8e9ff;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ cols }) => cols === 2 ? '1fr 1fr' : '1fr'};
  gap: 20px 24px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
`;

export const Input = styled.input`
  height: 44px;
  border: 1.5px solid ${({ error }) => (error ? '#e53e3e' : '#d1d5db')};
  border-radius: 10px;
  padding: 0 14px;
  font-size: 0.95rem;
  color: #222;
  background: ${({ readOnly }) => (readOnly ? '#f0f2ff' : '#fff')};
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #1410df;
  }

  &:disabled {
    background: #f0f2ff;
    color: #555;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const Select = styled.select`
  height: 44px;
  border: 1.5px solid ${({ error }) => (error ? '#e53e3e' : '#d1d5db')};
  border-radius: 10px;
  padding: 0 14px;
  font-size: 0.95rem;
  color: #222;
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s;

  &:focus {
    border-color: #1410df;
  }
`;

export const InputWithButton = styled.div`
  display: flex;
  gap: 10px;

  ${Input} {
    flex: 1;
  }
`;

export const SearchButton = styled.button`
  height: 44px;
  padding: 0 20px;
  background: #1410df;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover:not(:disabled) {
    background: #0f0db8;
  }

  &:disabled {
    background: #a5a5e8;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.span`
  font-size: 0.8rem;
  color: #e53e3e;
`;

export const AlertBox = styled.div`
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-top: 4px;
  background: ${({ type }) => (type === 'error' ? '#fff5f5' : '#f0fff4')};
  color: ${({ type }) => (type === 'error' ? '#c53030' : '#276749')};
  border: 1px solid ${({ type }) => (type === 'error' ? '#feb2b2' : '#9ae6b4')};
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 52px;
  background: #1410df;
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #0f0db8;
  }

  &:disabled {
    background: #a5a5e8;
    cursor: not-allowed;
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
